module.exports = __webpack_public_path__ + "static/media/dots-vertical1.0ddfa437.svg";